import {Service, service, inject} from "./di";
import {ConfigService} from "./ConfigService";
import MetadataService from "./MetadataService";

@service
export default class MerchantService extends Service {
	@inject configService: ConfigService;
	@inject metadataService: MetadataService;

	async fetchMerchantsListByName(name: string) {
		const response = await fetch(`${this.getRootUrl()}/stores/${name}?locale=${this.metadataService.getLocale()}`);
		return response.json();
	}

	private getRootUrl() {
		return this.configService.FLIPP_COM_APIS;
	}
}
